import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import axios from "axios";
import { toast } from "react-toastify";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import { IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { Controller } from "react-hook-form";
import {
  StyledTextField,
  StyledTextFieldBootstrap,
} from "../../doctor-console/StyledComponents";

const CareContextCreationNonAbdm = ({ abhaId, handleClose }) => {
  const [patientList, setPatientList] = useState([]);
  const [selectedPatient, setSelectedPatient] = useState(null);
  const [showDemographic, setShowDemographic] = useState(false);
  const [showSubmit, setShowSubmit] = useState(false);

  const {
    register,
    handleSubmit,
    formState: { errors },
    setError,
    control,
    getValues,
    setValue,
    watch,
    reset,
  } = useForm();

  const {
    register: register1,
    handleSubmit: handleSubmit1,
    formState: { errors: errors1 },
    setError: setError1,
    getValues: getValues1,
    setValue: setValue1,
    reset: reset1,
  } = useForm();

  const {
    register: register2,
    handleSubmit: handleSubmit2,
    formState: { errors: errors2 },
    setError: setError2,
    getValues: getValues2,
    setValue: setValue2,
    reset: reset2,
  } = useForm();

  const REACT_APP_BACKEND_ROUTE_URL = process.env.REACT_APP_BACKEND_ROUTE_URL;
  const [authToken, setAuthToken] = useState(
    sessionStorage.getItem("accessToken") !== undefined &&
      sessionStorage.getItem("accessToken") !== null
      ? sessionStorage.getItem("accessToken")
      : ""
  );
  const headers = {
    Authorization: `Bearer ${authToken}`,
  };
  const resetForm = () => {
    reset();
    reset1();
    reset2();
    setShowDemographic(false);
    setShowSubmit(false);
  };
  useEffect(() => {
    if (authToken !== "") {
      axios
        .get(
          `${REACT_APP_BACKEND_ROUTE_URL}get_patient_list_with_aabha_info/`,
          {
            headers: headers,
          }
        )
        .then((res) => {
          setPatientList(res.data?.data);
        });
    }
  }, [authToken]);

  const findPatient = (data) => {
    const foundPatient = patientList.find(
      (patient) => patient.patient_id === data.patient_id
    );
    if (foundPatient) {
      setShowDemographic(true);
      setSelectedPatient(foundPatient);
      setValue1("name", foundPatient.name);
      setValue1("gender", foundPatient.gender);
      setValue1("age", foundPatient.age);
      setValue1("phoneNo", foundPatient.phone_no);
      console.log("Patient found", foundPatient);
    } else {
      console.log("Patient not found");
    }
  };
  const next = () => {
    setShowSubmit(true);
  };
  // useEffect(() => {
  //   if (abhaId && patientList.length > 0) {
  //     const foundPatient = patientList.find(
  //       (patient) => patient.abha_id === abhaId
  //     );
  //     if (foundPatient) {
  //       console.log("found patient",foundPatient)
  //       setSelectedPatient(foundPatient.patient_id);
  //       setValue("patient_id", foundPatient.patient_id);
  //     }
  //   }
  // }, [abhaId,patientList]);
  useEffect(() => {
    if (abhaId && patientList.length > 0) {
      const foundPatient = patientList.find(
        (patient) => patient.abha_id === abhaId
      );
      if (foundPatient) {
        console.log("found patient", foundPatient);
        setSelectedPatient(foundPatient);
        setValue("patient_id", foundPatient.patient_id);
      }
    }
  }, [abhaId, patientList, setValue]);

  const patientId = watch("patient_id");

  const AddCareContext = () => {
    const reqBody = {
      patient_id: getValues("patient_id"),
      visit_details: getValues2("visit_details"),
    };
    axios
      .post(
        `${REACT_APP_BACKEND_ROUTE_URL}create_care_context/`,
        JSON.stringify(reqBody),
        {
          headers: headers,
        }
      )
      .then((res) => {
        if (res.data.status == "Success") {
          toast.success(
            `Visit Purpose Reference Id "${res.data.ref_num}"This ID will be used for linking to ABDM.`
          );
          resetForm();
          handleClose();
        } else {
          toast.error("some error occurred");
        }

        console.log("Add Visit Purpose", res.data);
      })
      .catch((err) => {
        console.log(err);
        toast.error(err);
      });
  };
  console.log("selected patid", selectedPatient);

  return (
    <>
      {/* Title moved inside the card */}

      <div className="col-sm-12 col-md-12 col-lg-12" style={{ margin: "auto" }}>
        {/* <div className="contact-panel mb-50"> */}
        {/* {abhaId && (
            <IconButton
              onClick={handleClose}
              style={{ position: "absolute", top: 0, right: 0 }}
            >
              <CloseIcon />
            </IconButton>
          )} */}
        {/* <div style={{ textAlign: "center" }} className="main-title">
            Create Visit Purpose
          </div> */}
        <form
          className="contact-panel__form"
          style={{ paddingTop: "3%" }}
          onSubmit={handleSubmit(findPatient)}
        >
          <div className="row">
            <div className="col-sm-12 col-md-12 col-lg-12">
              <div className="form-group">
                <label htmlFor="patient_id">Select a Patient</label>
                <Controller
                  name="patient_id"
                  control={control}
                  rules={{ required: "Patient is required." }}
                  render={({ field }) => (
                    <Autocomplete
                      {...field}
                      options={patientList}
                      getOptionLabel={(option) =>
                        `${option.name} ${option.patient_id}`
                      }
                      value={
                        patientList.find(
                          (patient) => patient.patient_id === patientId
                        ) || null
                      }
                      onChange={(_, value) => {
                        field.onChange(value?.patient_id || "");
                        setSelectedPatient(value);
                      }}
                      renderInput={(params) => (
                        <StyledTextFieldBootstrap
                          className="form-control"
                          {...params}
                          disabled={showDemographic}
                        />
                      )}
                      disabled={showDemographic}
                    />
                  )}
                />
                {errors.patient_id && (
                  <p className="errorMsg" style={{ color: "red" }}>
                    {errors.patient_id.message}
                  </p>
                )}
              </div>
            </div>
            <div className="col-12">
              <div className="row justify-content-center">
                <div className="col-sm-12 col-md-6 col-lg-6">
                  <button
                    type="submit"
                    className="btn btn__secondary btn__rounded btn__block btn__xhight mb-10"
                  >
                    <span>View demographics</span>{" "}
                    <i className="icon-arrow-right"></i>
                  </button>
                </div>
              </div>
              <div className="contact-result"></div>
            </div>
          </div>
        </form>

        {showDemographic && (
          <form
            className="contact-panel__form"
            style={{ paddingTop: "3%" }}
            onSubmit={handleSubmit1(next)}
          >
            <div className="row">
              <div className="col-sm-6 col-md-6 col-lg-6">
                <div className="form-group">
                  <label htmlFor="contextName">Name</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter Name"
                    name="contextName"
                    {...register1("name", {
                      required: "Name is required.",
                    })}
                    disabled
                  />
                  {errors1.name && (
                    <p className="errorMsg" style={{ color: "red" }}>
                      {errors1.name.message}
                    </p>
                  )}
                </div>
              </div>

              <div className="col-sm-6 col-md-6 col-lg-6">
                <div className="form-group">
                  <label htmlFor="gender">Gender</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter Gender"
                    name="gender"
                    {...register1("gender", {
                      required: "Gender is required.",
                    })}
                    disabled
                  />
                  {errors1.gender && (
                    <p className="errorMsg" style={{ color: "red" }}>
                      {errors1.gender.message}
                    </p>
                  )}
                </div>
              </div>
              <div className="col-sm-6 col-md-6 col-lg-6">
                <div className="form-group">
                  <label htmlFor="gender">Age</label>
                  <input
                    type="number"
                    className="form-control"
                    placeholder="Enter Age"
                    name="age"
                    {...register1("age", {
                      required: "Age is required.",
                      min: {
                        value: 0,
                        message: "Age must be a positive number.",
                      },
                    })}
                    disabled
                  />
                  {errors1.age && (
                    <p className="errorMsg" style={{ color: "red" }}>
                      {errors1.age.message}
                    </p>
                  )}
                </div>
              </div>

              <div className="col-sm-6 col-md-6 col-lg-6">
                <div className="form-group">
                  <label htmlFor="gender">Phone No</label>
                  <input
                    type="number"
                    className="form-control"
                    placeholder="--"
                    name="phoneNo"
                    {...register1("phoneNo", {
                      required: "phone no is required.",
                    })}
                    disabled
                  />
                  {errors1.phoneNo && (
                    <p className="errorMsg" style={{ color: "red" }}>
                      {errors1.phoneNo.message}
                    </p>
                  )}
                </div>
              </div>

              <div className="col-12">
                <div className="row justify-content-center">
                  <div className="col-sm-12 col-md-6 col-lg-6">
                    <button
                      type="submit"
                      className="btn btn__secondary btn__rounded btn__block btn__xhight mb-10"
                    >
                      <span>Next</span> <i className="icon-arrow-right"></i>
                    </button>
                  </div>
                </div>
                <div className="contact-result"></div>
              </div>
            </div>
          </form>
        )}
        {showSubmit && (
          <form
            className="contact-panel__form"
            style={{ paddingTop: "3%" }}
            onSubmit={handleSubmit2(AddCareContext)}
          >
            <div className="row">
              <div className="col-sm-12 col-md-12 col-lg-12">
                <div className="form-group">
                  <label htmlFor="gender">Enter Visit Details</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter Visit Details"
                    name="visit_details"
                    {...register2("visit_details", {
                      required: "Visit Details is required.",
                    })}
                  />
                  {errors2.visit_details && (
                    <p className="errorMsg" style={{ color: "red" }}>
                      {errors2.visit_details.message}
                    </p>
                  )}
                </div>
              </div>

              <div className="col-12">
                <div className="row justify-content-center">
                  <div className="col-sm-12 col-md-6 col-lg-6">
                    <button
                      type="submit"
                      className="btn btn__secondary btn__rounded btn__block btn__xhight mb-10"
                    >
                      <span>Submit</span> <i className="icon-arrow-right"></i>
                    </button>
                  </div>
                </div>
                <div className="contact-result"></div>
              </div>
            </div>
          </form>
        )}
      </div>
      {/* </div> */}
    </>
  );
};

export default CareContextCreationNonAbdm;
